<div class="contact-wrapper closed">
    <div class="wrapper newsletter-wrapper row column" *ngIf="hasNewsletterRegistration">
        <p
            [innerHTML]="(newsletterSubscriptionFinished === false? 'contact.teaser.newsletter' : 'contact.teaser.newsletter.subscribed') | translate">
        </p>
        <div class="row" [class.medium-collapse]="!hasNewsletterNamerequest"
            *ngIf="newsletterSubscriptionFinished === false">
            <textfield [(model)]="contact.data.email" [fieldType]="'email'" [name]="'email'"
                [label]="getLabelKeyForField('email') | translate" [required]="true"
                [wrapperClass]="hasNewsletterNamerequest? 'column small-12 medium-3' : 'columns small-12 medium-5 medium-offset-2'"
                [form]="form" (onBlur)="correctEmailAddress()"></textfield>

            <textfield *ngIf="hasNewsletterNamerequest" [(model)]="contact.data.firstname" [name]="'firstname'"
                [label]="getLabelKeyForField('firstname') | translate" [wrapperClass]="'columns small-6 medium-3'"
                [form]="form"></textfield>
            <textfield *ngIf="hasNewsletterNamerequest" [(model)]="contact.data.lastname" [name]="'lastname'"
                [label]="getLabelKeyForField('lastname') | translate" [wrapperClass]="'columns small-6 medium-3'"
                [form]="form"></textfield>
            <div class="column small-12 medium-3 end">
                <button class="button primary" [innerHTML]="'contact.newsletter.button' | translate"
                    (click)="submitNewsletter()"></button>
            </div>
        </div>
    </div>
</div>